const getRootAttributes = () => {
    const root = document.getElementById("op-occasion-picker");

    return {
        ...root.dataset
    };
};

export default getRootAttributes